import React, { useEffect, useState } from "react"
import axios from "axios"
const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

interface Categoria { id: string; nome: string }
interface Marca { id: string; nome: string; ativo: boolean; tipo_id: string | null }
interface Modelo { id: string; marca_id: string; nome: string; ativo: boolean }

export default function MarcasModelos() {
  const [categorias, setCategorias] = useState<Categoria[]>([])
  const [categoriaSelecionada, setCategoriaSelecionada] = useState<Categoria | null>(null)
  const [marcas, setMarcas] = useState<Marca[]>([])
  const [modelos, setModelos] = useState<Modelo[]>([])
  const [marcaSelecionada, setMarcaSelecionada] = useState<Marca | null>(null)
  const [novoModelo, setNovoModelo] = useState("")
  const [editandoModelo, setEditandoModelo] = useState<Modelo | null>(null)
  const [carregando, setCarregando] = useState(true)
  const [erro, setErro] = useState("")

  const [modalAberto, setModalAberto] = useState(false)
  const [modalModoEdicao, setModalModoEdicao] = useState(false)
  const [modalMarcaOriginal, setModalMarcaOriginal] = useState<Marca | null>(null)
  const [modalNomeMarca, setModalNomeMarca] = useState("")
  const [modalCategoriaIds, setModalCategoriaIds] = useState<string[]>([])
  const [modalCategoriaIdsOriginais, setModalCategoriaIdsOriginais] = useState<string[]>([])
  const [modalIdsPorCategoria, setModalIdsPorCategoria] = useState<Record<string, string>>({})
  const [modalModelos, setModalModelos] = useState<string[]>([""])
  const [modalErro, setModalErro] = useState("")
  const [modalSalvando, setModalSalvando] = useState(false)

  const token = () => localStorage.getItem("moobi_token")
  const headers = () => ({ Authorization: `Bearer ${token()}` })

  const carregarCategorias = async () => {
    const r = await axios.get(`${API}/ativos/tipos`, { headers: headers() })
    setCategorias(r.data)
  }

  const carregarMarcas = async (categoriaId: string) => {
    const r = await axios.get(`${API}/marcas`, { headers: headers(), params: { tipo_id: categoriaId } })
    setMarcas(r.data)
  }

  const carregarModelos = async (marcaId: string) => {
    const r = await axios.get(`${API}/modelos`, { headers: headers(), params: { marca_id: marcaId } })
    setModelos(r.data)
  }

  useEffect(() => {
    (async () => {
      setCarregando(true)
      await carregarCategorias()
      setCarregando(false)
    })()
  }, [])

  useEffect(() => {
    setMarcaSelecionada(null)
    if (categoriaSelecionada) carregarMarcas(categoriaSelecionada.id)
    else setMarcas([])
  }, [categoriaSelecionada])

  useEffect(() => {
    if (marcaSelecionada) carregarModelos(marcaSelecionada.id)
    else setModelos([])
  }, [marcaSelecionada])

  const abrirModalNovo = () => {
    setModalModoEdicao(false)
    setModalMarcaOriginal(null)
    setModalNomeMarca("")
    setModalCategoriaIds(categoriaSelecionada ? [categoriaSelecionada.id] : [])
    setModalCategoriaIdsOriginais([])
    setModalIdsPorCategoria({})
    setModalModelos([""])
    setModalErro("")
    setModalAberto(true)
  }

  const abrirModalEditar = async (m: Marca) => {
    setModalModoEdicao(true)
    setModalMarcaOriginal(m)
    setModalNomeMarca(m.nome)
    setModalErro("")
    setModalModelos([""])
    try {
      const r = await axios.get(`${API}/marcas`, { headers: headers() })
      const irmas: Marca[] = r.data.filter((x: Marca) => x.nome.trim().toLowerCase() === m.nome.trim().toLowerCase())
      const idsCategorias = irmas.filter(x => x.tipo_id).map(x => x.tipo_id as string)
      const mapaIds: Record<string, string> = {}
      irmas.forEach(x => { if (x.tipo_id) mapaIds[x.tipo_id] = x.id })
      setModalCategoriaIds(idsCategorias)
      setModalCategoriaIdsOriginais(idsCategorias)
      setModalIdsPorCategoria(mapaIds)
    } catch {
      setModalCategoriaIds(m.tipo_id ? [m.tipo_id] : [])
      setModalCategoriaIdsOriginais(m.tipo_id ? [m.tipo_id] : [])
      setModalIdsPorCategoria(m.tipo_id ? { [m.tipo_id]: m.id } : {})
    }
    setModalAberto(true)
  }

  const alternarCategoriaModal = (id: string) => {
    setModalCategoriaIds(atuais => atuais.includes(id) ? atuais.filter(c => c !== id) : [...atuais, id])
  }

  const atualizarModeloModal = (indice: number, valor: string) => {
    setModalModelos(atuais => atuais.map((m, i) => i === indice ? valor : m))
  }

  const adicionarLinhaModelo = () => setModalModelos(atuais => [...atuais, ""])

  const removerLinhaModelo = (indice: number) => {
    setModalModelos(atuais => atuais.length === 1 ? atuais : atuais.filter((_, i) => i !== indice))
  }

  const salvarModal = async () => {
    const nome = modalNomeMarca.trim()
    if (!nome) { setModalErro("Digite o nome da marca"); return }
    if (modalCategoriaIds.length === 0) { setModalErro("Selecione ao menos uma categoria"); return }
    setModalErro("")
    setModalSalvando(true)
    try {
      const nomesModelos = modalModelos.map(m => m.trim()).filter(Boolean)

      if (!modalModoEdicao) {
        for (const catId of modalCategoriaIds) {
          const respMarca = await axios.post(`${API}/marcas`, { nome, tipo_id: catId }, { headers: headers() })
          for (const nomeModelo of nomesModelos) {
            await axios.post(`${API}/modelos`, { marca_id: respMarca.data.id, nome: nomeModelo }, { headers: headers() }).catch(() => {})
          }
        }
      } else {
        const adicionadas = modalCategoriaIds.filter(id => !modalCategoriaIdsOriginais.includes(id))
        const removidas = modalCategoriaIdsOriginais.filter(id => !modalCategoriaIds.includes(id))
        const mantidas = modalCategoriaIds.filter(id => modalCategoriaIdsOriginais.includes(id))

        if (removidas.length > 0) {
          const confirmou = window.confirm(
            `Isso vai remover "${nome}" de ${removidas.length} categoria(s) que não estão mais marcadas — os modelos cadastrados nelas também somem. Confirmar?`
          )
          if (!confirmou) { setModalSalvando(false); return }
        }

        for (const catId of adicionadas) {
          const respMarca = await axios.post(`${API}/marcas`, { nome, tipo_id: catId }, { headers: headers() })
          for (const nomeModelo of nomesModelos) {
            await axios.post(`${API}/modelos`, { marca_id: respMarca.data.id, nome: nomeModelo }, { headers: headers() }).catch(() => {})
          }
        }
        for (const catId of removidas) {
          const idParaRemover = modalIdsPorCategoria[catId]
          if (idParaRemover) await axios.delete(`${API}/marcas/${idParaRemover}`, { headers: headers() }).catch(() => {})
        }
        for (const catId of mantidas) {
          const idParaAtualizar = modalIdsPorCategoria[catId]
          if (idParaAtualizar) await axios.put(`${API}/marcas/${idParaAtualizar}`, { nome }, { headers: headers() }).catch(() => {})
        }
      }

      setModalAberto(false)
      setMarcaSelecionada(null)
      if (categoriaSelecionada) await carregarMarcas(categoriaSelecionada.id)
    } catch (e: any) {
      setModalErro(e.response?.data?.erro || "Erro ao salvar")
    } finally {
      setModalSalvando(false)
    }
  }

  const excluirMarca = async (m: Marca) => {
    if (!window.confirm(`Remover a marca "${m.nome}" dessa categoria? Os modelos dela também deixam de aparecer em cadastros novos.`)) return
    await axios.delete(`${API}/marcas/${m.id}`, { headers: headers() })
    if (marcaSelecionada?.id === m.id) setMarcaSelecionada(null)
    if (categoriaSelecionada) await carregarMarcas(categoriaSelecionada.id)
  }

  const criarModelo = async () => {
    if (!novoModelo.trim() || !marcaSelecionada) return
    setErro("")
    try {
      await axios.post(`${API}/modelos`, { marca_id: marcaSelecionada.id, nome: novoModelo.trim() }, { headers: headers() })
      setNovoModelo("")
      await carregarModelos(marcaSelecionada.id)
    } catch (e: any) { setErro(e.response?.data?.erro || "Erro ao criar modelo") }
  }

  const salvarEdicaoModelo = async () => {
    if (!editandoModelo) return
    try {
      await axios.put(`${API}/modelos/${editandoModelo.id}`, { nome: editandoModelo.nome }, { headers: headers() })
      setEditandoModelo(null)
      if (marcaSelecionada) await carregarModelos(marcaSelecionada.id)
    } catch (e: any) { setErro(e.response?.data?.erro || "Erro ao editar modelo") }
  }

  const excluirModelo = async (mo: Modelo) => {
    if (!window.confirm(`Remover o modelo "${mo.nome}"?`)) return
    await axios.delete(`${API}/modelos/${mo.id}`, { headers: headers() })
    if (marcaSelecionada) await carregarModelos(marcaSelecionada.id)
  }

  const corFundo = "#0d1b2e", corCard = "#1e2f4a", corBorda = "#2d4166", corTexto = "#f1f5f9", corMuted = "#94a3b8", corAccent = "#0ea5e9"

  const estiloInput: React.CSSProperties = {
    flex: 1, padding: "9px 12px", borderRadius: 8, border: `1px solid ${corBorda}`,
    background: corCard, color: corTexto, fontSize: 13, boxSizing: "border-box",
  }
  const estiloSelect: React.CSSProperties = { ...estiloInput, maxWidth: 320 }
  const estiloBotao: React.CSSProperties = {
    padding: "9px 16px", borderRadius: 8, border: "none", cursor: "pointer",
    background: corAccent, color: "#fff", fontSize: 13, fontWeight: 600, whiteSpace: "nowrap",
  }
  const estiloLinha: React.CSSProperties = {
    display: "flex", alignItems: "center", gap: 8, padding: "10px 12px",
    borderRadius: 8, border: `1px solid ${corBorda}`, marginBottom: 6,
  }
  const estiloIconeAcao: React.CSSProperties = { cursor: "pointer", color: corMuted, fontSize: 15, padding: 4 }

  if (carregando) return <div style={{ padding: 32, color: corMuted }}>Carregando...</div>

  return (
    <div style={{ padding: 24, height: "100%", overflow: "auto", background: corFundo, color: corTexto }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 4 }}>
        <div>
          <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 4 }}>Marcas e Modelos</h2>
          <p style={{ fontSize: 12, color: corMuted }}>
            Catálogo usado no cadastro de ativos — cada marca pertence a uma ou mais categorias (ex: Volkswagen em Carro e em Picape).
          </p>
        </div>
        <button style={estiloBotao} onClick={abrirModalNovo}>+ Nova marca</button>
      </div>
      {!!erro && <div style={{ color: "#f87171", fontSize: 12, marginTop: 12 }}>{erro}</div>}

      <div style={{ marginTop: 20, marginBottom: 20 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: corMuted, marginBottom: 8, textTransform: "uppercase", letterSpacing: 0.5 }}>Filtrar por categoria</div>
        <select style={estiloSelect} value={categoriaSelecionada?.id || ""}
          onChange={e => setCategoriaSelecionada(categorias.find(c => c.id === e.target.value) || null)}>
          <option value="">— Selecione a categoria —</option>
          {categorias.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
        </select>
      </div>

      {!categoriaSelecionada ? (
        <div style={{ color: corMuted, fontSize: 12 }}>Escolha uma categoria acima pra ver as marcas dela.</div>
      ) : (
        <div style={{ display: "flex", gap: 20, alignItems: "flex-start" }}>
          <div style={{ flex: 1, minWidth: 280 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: corMuted, marginBottom: 10, textTransform: "uppercase", letterSpacing: 0.5 }}>
              Marcas — {categoriaSelecionada.nome}
            </div>
            {marcas.map(m => (
              <div key={m.id} style={{ ...estiloLinha, background: marcaSelecionada?.id === m.id ? "rgba(14,165,233,0.1)" : "transparent", cursor: "pointer" }}
                onClick={() => setMarcaSelecionada(m)}>
                <span style={{ flex: 1, fontSize: 13 }}>{m.nome}</span>
                {!m.tipo_id && <span title="Cadastro antigo, sem categoria definida" style={{ fontSize: 10, color: "#fbbf24" }}>⚠️ sem categoria</span>}
                <span style={estiloIconeAcao} onClick={e => { e.stopPropagation(); abrirModalEditar(m) }}>✏️</span>
                <span style={estiloIconeAcao} onClick={e => { e.stopPropagation(); excluirMarca(m) }}>🗑️</span>
              </div>
            ))}
            {marcas.length === 0 && <div style={{ color: corMuted, fontSize: 12 }}>Nenhuma marca cadastrada pra essa categoria ainda. Use o botão "+ Nova marca" no topo.</div>}
          </div>

          <div style={{ flex: 1, minWidth: 280 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: corMuted, marginBottom: 10, textTransform: "uppercase", letterSpacing: 0.5 }}>
              Modelos {marcaSelecionada ? `— ${marcaSelecionada.nome}` : ""}
            </div>
            {!marcaSelecionada ? (
              <div style={{ color: corMuted, fontSize: 12 }}>Selecione uma marca à esquerda pra ver/adicionar os modelos dela.</div>
            ) : (
              <>
                <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
                  <input style={estiloInput} placeholder="Novo modelo (ex: Delivery)" value={novoModelo}
                    onChange={e => setNovoModelo(e.target.value)} onKeyDown={e => e.key === "Enter" && criarModelo()} />
                  <button style={estiloBotao} onClick={criarModelo}>+ Adicionar</button>
                </div>
                {modelos.map(mo => (
                  <div key={mo.id} style={estiloLinha}>
                    {editandoModelo?.id === mo.id ? (
                      <>
                        <input style={estiloInput} value={editandoModelo.nome}
                          onChange={e => setEditandoModelo({ ...editandoModelo, nome: e.target.value })} autoFocus />
                        <span style={estiloIconeAcao} onClick={salvarEdicaoModelo}>✅</span>
                        <span style={estiloIconeAcao} onClick={() => setEditandoModelo(null)}>✖️</span>
                      </>
                    ) : (
                      <>
                        <span style={{ flex: 1, fontSize: 13 }}>{mo.nome}</span>
                        <span style={estiloIconeAcao} onClick={() => setEditandoModelo(mo)}>✏️</span>
                        <span style={estiloIconeAcao} onClick={() => excluirModelo(mo)}>🗑️</span>
                      </>
                    )}
                  </div>
                ))}
                {modelos.length === 0 && <div style={{ color: corMuted, fontSize: 12 }}>Nenhum modelo cadastrado pra essa marca ainda.</div>}
              </>
            )}
          </div>
        </div>
      )}

      {modalAberto && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 999,
          display: "flex", alignItems: "center", justifyContent: "center" }}
          onClick={() => !modalSalvando && setModalAberto(false)}>
          <div style={{ background: corFundo, border: `1px solid ${corBorda}`, borderRadius: 12, padding: 28, width: 460,
            maxHeight: "85vh", overflow: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.5)" }}
            onClick={e => e.stopPropagation()}>
            <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 18 }}>
              {modalModoEdicao ? `✏️ Editar "${modalMarcaOriginal?.nome}"` : "🚗 Nova marca"}
            </h3>

            {!!modalErro && <div style={{ color: "#f87171", fontSize: 12, marginBottom: 12 }}>{modalErro}</div>}

            <label style={{ fontSize: 12, color: corMuted, display: "block", marginBottom: 6 }}>Categorias * — marque uma ou mais</label>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 16 }}>
              {categorias.map(c => {
                const marcada = modalCategoriaIds.includes(c.id)
                return (
                  <button type="button" key={c.id} onClick={() => alternarCategoriaModal(c.id)} disabled={modalSalvando}
                    style={{ padding: "7px 14px", borderRadius: 20, cursor: "pointer", fontSize: 12.5,
                      border: `1px solid ${marcada ? corAccent : corBorda}`,
                      background: marcada ? "rgba(14,165,233,0.15)" : "transparent",
                      color: marcada ? "#38bdf8" : corMuted, fontWeight: marcada ? 600 : 400 }}>
                    {marcada ? "✓ " : ""}{c.nome}
                  </button>
                )
              })}
            </div>
            {modalModoEdicao && (
              <div style={{ fontSize: 11, color: corMuted, marginTop: -8, marginBottom: 16 }}>
                Desmarcar uma categoria remove essa marca dela (e os modelos cadastrados lá). Marcar uma nova cria o cadastro nessa categoria.
              </div>
            )}

            <label style={{ fontSize: 12, color: corMuted, display: "block", marginBottom: 6 }}>Nome da marca *</label>
            <input style={{ ...estiloInput, marginBottom: 16, width: "100%" }} placeholder="Ex: Volkswagen"
              value={modalNomeMarca} onChange={e => setModalNomeMarca(e.target.value)} disabled={modalSalvando} autoFocus />

            {!modalModoEdicao && (
              <>
                <label style={{ fontSize: 12, color: corMuted, display: "block", marginBottom: 6 }}>Modelos — opcional, pode adicionar vários</label>
                {modalModelos.map((valor, i) => (
                  <div key={i} style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                    <input style={estiloInput} placeholder={`Ex: ${i === 0 ? "Gol" : "Strada"}`} value={valor}
                      onChange={e => atualizarModeloModal(i, e.target.value)} disabled={modalSalvando} />
                    <span style={{ ...estiloIconeAcao, opacity: modalModelos.length === 1 ? 0.3 : 1, pointerEvents: modalModelos.length === 1 ? "none" : "auto" }}
                      onClick={() => removerLinhaModelo(i)}>🗑️</span>
                  </div>
                ))}
                <button type="button" onClick={adicionarLinhaModelo} disabled={modalSalvando}
                  style={{ background: "none", border: `1px dashed ${corBorda}`, borderRadius: 8, color: corAccent,
                    padding: "8px 12px", fontSize: 12, cursor: "pointer", width: "100%", marginBottom: 20 }}>
                  + Adicionar outro modelo
                </button>
              </>
            )}

            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: modalModoEdicao ? 8 : 0 }}>
              <button onClick={() => setModalAberto(false)} disabled={modalSalvando}
                style={{ padding: "9px 16px", borderRadius: 8, border: `1px solid ${corBorda}`, background: "none", color: corMuted, cursor: "pointer", fontSize: 13 }}>
                Cancelar
              </button>
              <button onClick={salvarModal} disabled={modalSalvando} style={estiloBotao}>
                {modalSalvando ? "Salvando..." : "💾 Salvar"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
